<ng-container *ngIf="!!requests">
  <table class="table table-compact tabletop small" *ngIf="requests.length > 0">
    <thead>
    <tr>
      <th class="left">Anfrage</th>
      <th class="left">Lieferant</th>
      <th class="left">Position</th>
      <th class="left">Bezeichnung</th>
      <th class="currency">Summe (netto)</th>
      <th class="right">Anzahl</th>
      <th *ngIf="jobid !== 0"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let request of requests">
      <td class="left" [routerLink]="['/request/details', request.project_number, request.reqid]">{{ request.project_number }}.0001.{{ request.reqid }}</td>
      <td class="left">{{ request.company_name }}</td>
      <td class="left">{{ request.position }}<span *ngIf="request.part !== 0">.{{ request.part }}</span> </td>
      <td class="left">{{ request.name }}</td>
      <td class="currency"><b>{{ request.purchasing_price | currency: "EUR":'code':'1.2-2':'de' }}</b></td>
      <td class="right">{{ request.number_of_pieces }}</td>
      <td *ngIf="jobid !== 0"><button class="btn btn-primary btn-sm" [clrLoading]="createOrderState" (click)="createOrder(request.project_number, request.reqid, jobid)">Beauftragen</button></td>
    </tr>
    </tbody>
  </table>
</ng-container>
